/* cstrap-len.js — dropdown Strap Length tu dung (03/10, chu shop). Nap boi sections/custom-strap-form.liquid CHI tren
   strap-classic / strap-exotic / strap-rally. Cung ma voi ban strap-v2 (cstrap-mto-v2.js). */
(function () {
  'use strict';
  /* ==================================================================
     Dropdown Strap Length tu dung (chu shop 03/10, PC + mobile).
     - <select> goc VAN O DO (an bang class .clen-an) -> submit, validate, engine, may tinh size doc/ghi nhu cu.
     - O dong = <button> chep computed style cua select goc (cao, dem, chu, mau, vien, mui ten) -> giong het cac
       dropdown khac cua tung kho, ke ca mau chu trong/da chon va vien do khi thieu.
     - List: moi dong trai "M — 115/70 mm", phai chu thich co tay lay tu BANG SIZE cua popup (.ssize-table —
       cung nguon voi may tinh size). Value / properties[Length] giu nguyen.
     ================================================================== */
  function cstrapLenDropdown(sel) {
    if (!sel || sel.dataset.clen) return;
    sel.dataset.clen = '1';
    var doc = sel.ownerDocument;
    var uid = 'clen-' + Math.random().toString(36).slice(2, 8);

    /* chu thich co tay: bang size cua popup Length (cung bang may tinh size doc) */
    function bangCoTay() {
      var m = {};
      var tr = doc.querySelectorAll('.sguide-panel[data-guide="length"] .ssize-table tbody tr, .ssize-table tbody tr');
      for (var i = 0; i < tr.length; i++) {
        var td = tr[i].querySelectorAll('td'); if (td.length < 2) continue;
        var size = td[1].textContent.replace(/\s+/g, ' ').trim();
        if (!size || /^(custom|my own)/i.test(size) || m[size]) continue;   /* 08/10: dong cuoi bang = "My own size" */
        var co = td[0].textContent.replace(/\s+/g, ' ').trim()
          .replace(/(\d+)\.0(?!\d)/g, '$1')          /* 15.0 -> 15, 17.0 -> 17 */
          .replace(/\s*[–-]\s*/g, '–');               /* "15.1 – 15.8" -> "15.1–15.8" */
        m[size] = 'wrist ' + co;
      }
      return m;
    }
    var CO = bangCoTay();
    /* chu NGAN = chu goc Liquid cua option (nho lai mot lan); chu DAI (mobile) = ngan + " (co tay)" */
    function chuNgan(o) {
      if (o.dataset.clenNgan === undefined) { var t0 = o.textContent.replace(/\s+/g, ' ').trim(); if (/^wrist\b/i.test(t0)) { o.dataset.dai = t0; o.dataset.clenNgan = o.value; } else o.dataset.clenNgan = t0; }   /* 08/10 15:26: option Liquid "Wrist 15.6–16.5 cm — M · 115/70 mm" -> chu ngan = gia tri */
      return o.dataset.clenNgan;
    }
    function chuDai(o) {
      var n = chuNgan(o), k = String(o.value || '').split(' — ')[0].trim();
      if (!o.value || /^custom/i.test(o.value) || !CO[k]) return n;
      return o.dataset.dai || (/\bwrist\b/i.test(n) ? n : n + ' · ' + CO[k]);   /* 08/10 16:05: option "16 cm wrist — 115/70 mm" da co co tay */
    }
    function laMb() { return !!(window.matchMedia && window.matchMedia('(max-width: 749px)').matches); }

    /* --- dung DOM --- */
    var hop = doc.createElement('div');
    hop.className = 'clen';
    var nut = doc.createElement('button');
    nut.type = 'button';
    nut.className = 'clen__nut';
    nut.setAttribute('aria-haspopup', 'listbox');
    nut.setAttribute('aria-expanded', 'false');
    nut.setAttribute('aria-controls', uid);
    var lb = sel.id ? doc.querySelector('label[for="' + sel.id + '"]') : null;
    if (lb) { if (!lb.id) lb.id = uid + '-lb'; nut.setAttribute('aria-labelledby', lb.id + ' ' + uid + '-nut'); }
    nut.id = uid + '-nut';
    var ds = doc.createElement('ul');
    ds.className = 'clen__ds';
    ds.id = uid;
    ds.setAttribute('role', 'listbox');
    ds.setAttribute('tabindex', '-1');
    ds.hidden = true;
    hop.appendChild(nut);
    hop.appendChild(ds);
    sel.insertAdjacentElement('afterend', hop);
    sel.classList.add('clen-an');
    sel.setAttribute('tabindex', '-1');
    sel.setAttribute('aria-hidden', 'true');

    var dong = [];
    function veDanhSach() {
      ds.innerHTML = ''; dong = [];
      for (var i = 0; i < sel.options.length; i++) {
        var o = sel.options[i];
        if (!o.value || o.disabled) continue;
        var li = doc.createElement('li');
        li.className = 'clen__dong';
        li.id = uid + '-o' + i;
        li.setAttribute('role', 'option');
        li.dataset.v = o.value;
        var a = doc.createElement('span'); a.className = 'clen__chinh'; a.textContent = chuNgan(o) && (o.dataset.dai || chuNgan(o));   /* 08/10 15:26: list ghi co tay truoc */
        li.appendChild(a);
        var k = o.value.split(' — ')[0].trim();
        if (!o.dataset.dai && !/\bwrist\b/i.test(chuNgan(o)) && CO[k] && !/^custom/i.test(o.value)) { var b = doc.createElement('span'); b.className = 'clen__phu'; b.textContent = CO[k]; li.appendChild(b); }
        ds.appendChild(li); dong.push(li);
      }
    }

    /* o dong: chu = option dang chon (placeholder neu trong); kieu = chep select goc */
    var KIEU = ['height', 'min-height', 'padding-top', 'padding-right', 'padding-bottom', 'padding-left', 'font-family', 'font-size',
      'font-weight', 'line-height', 'letter-spacing', 'color', 'background-color', 'background-image', 'background-position',
      'background-size', 'background-repeat', 'border-top-width', 'border-right-width', 'border-bottom-width', 'border-left-width',
      'border-top-style', 'border-right-style', 'border-bottom-style', 'border-left-style', 'border-top-color', 'border-right-color',
      'border-bottom-color', 'border-left-color', 'border-top-left-radius', 'border-top-right-radius', 'border-bottom-left-radius',
      'border-bottom-right-radius', 'box-shadow', 'text-transform'];
    /* 03/10: kich thuoc lay tu o Lug Width (dropdown ngay tren) neu co, mau/trang thai lay tu select Length (chu xam khi trong,
       vien do khi thieu). iPhone: luat @supports(-webkit-touch-callout) ve select o 16px roi transform scale(.8125) de khong
       zoom — o moi khong phai o nhap nen nhan he so scale vao moi so px -> nhin GIONG HET o Lug Width. */
    var TRANG_THAI = { 'color': 1, 'background-color': 1, 'border-top-color': 1, 'border-right-color': 1, 'border-bottom-color': 1, 'border-left-color': 1 };
    function heSo(c) {
      var t = c.getPropertyValue('transform');
      if (!t || t === 'none') return 1;
      var m = t.match(/matrix\(\s*([-\d.e]+)/);
      return m ? (parseFloat(m[1]) || 1) : 1;
    }
    function chepKieu() {
      var lug = (sel.form || doc).querySelector('select[name="properties[Lug Width]"]');
      var mau = lug && lug !== sel && lug.getClientRects().length ? lug : sel;
      var cm = getComputedStyle(mau), cs = getComputedStyle(sel), k = heSo(cm);
      for (var i = 0; i < KIEU.length; i++) {
        var p = KIEU[i], v = (TRANG_THAI[p] ? cs : cm).getPropertyValue(p);
        if (k !== 1 && !TRANG_THAI[p]) v = v.replace(/(-?\d*\.?\d+)px/g, function (_, n) { return (parseFloat(n) * k).toFixed(3) + 'px'; });
        nut.style.setProperty(p, v);
      }
    }
    function veNut() {
      var o = sel.options[sel.selectedIndex];
      nut.textContent = o ? chuNgan(o) : '';
      nut.classList.toggle('is-trong', !sel.value);
      for (var i = 0; i < dong.length; i++) {
        var on = dong[i].dataset.v === sel.value;
        dong[i].classList.toggle('is-chon', on);
        dong[i].setAttribute('aria-selected', on ? 'true' : 'false');
      }
      requestAnimationFrame(chepKieu);
    }

    /* --- mo / dong / chon --- */
    var dangChi = -1;
    function chi(i, khongCuon) {
      if (!dong.length) return;
      dangChi = Math.max(0, Math.min(dong.length - 1, i));
      for (var j = 0; j < dong.length; j++) dong[j].classList.toggle('is-chi', j === dangChi);
      nut.setAttribute('aria-activedescendant', dong[dangChi].id);
      if (khongCuon) return;
      var r = dong[dangChi];
      if (r.offsetTop < ds.scrollTop) ds.scrollTop = r.offsetTop;
      else if (r.offsetTop + r.offsetHeight > ds.scrollTop + ds.clientHeight) ds.scrollTop = r.offsetTop + r.offsetHeight - ds.clientHeight;
    }
    function mo() {
      if (!ds.hidden) return;
      veDanhSach(); veNut();
      ds.hidden = false; hop.classList.add('is-mo');
      nut.setAttribute('aria-expanded', 'true');
      var k = -1; for (var i = 0; i < dong.length; i++) if (dong[i].dataset.v === sel.value) k = i;
      chi(k < 0 ? 0 : k);
    }
    function dongLai(veNutLai) {
      if (ds.hidden) return;
      ds.hidden = true; hop.classList.remove('is-mo');
      nut.setAttribute('aria-expanded', 'false');
      nut.removeAttribute('aria-activedescendant');
      if (veNutLai) nut.focus();
    }
    function chon(i) {
      var li = dong[i]; if (!li) return;
      if (sel.value !== li.dataset.v) {
        sel.value = li.dataset.v;
        sel.dispatchEvent(new Event('input', { bubbles: true }));
        sel.dispatchEvent(new Event('change', { bubbles: true }));
      }
      dongLai(true); veNut();
    }

    nut.addEventListener('click', function () { if (ds.hidden) mo(); else dongLai(false); });
    nut.addEventListener('keydown', function (e) {
      var k = e.key;
      if (ds.hidden) {
        if (k === 'ArrowDown' || k === 'ArrowUp' || k === 'Enter' || k === ' ') { e.preventDefault(); mo(); }
        return;
      }
      if (k === 'ArrowDown') { e.preventDefault(); chi(dangChi + 1); }
      else if (k === 'ArrowUp') { e.preventDefault(); chi(dangChi - 1); }
      else if (k === 'Home') { e.preventDefault(); chi(0); }
      else if (k === 'End') { e.preventDefault(); chi(dong.length - 1); }
      else if (k === 'Enter' || k === ' ') { e.preventDefault(); chon(dangChi); }
      else if (k === 'Escape') { e.preventDefault(); dongLai(true); }
      else if (k === 'Tab') { dongLai(false); }
    });
    /* tro chuot / cham -> to ngay (nen #1A1A1A); cham tren mobile: to roi moi chon (nhin thay dong vua cham) */
    ds.addEventListener('mouseover', function (e) { var li = e.target.closest('.clen__dong'); if (li) chi(dong.indexOf(li), true); });
    ds.addEventListener('pointerdown', function (e) { var li = e.target.closest('.clen__dong'); if (li) chi(dong.indexOf(li), true); });
    ds.addEventListener('click', function (e) {
      var li = e.target.closest('.clen__dong'); if (!li) return;
      var i = dong.indexOf(li); chi(i, true);
      setTimeout(function () { chon(i); }, 120);
    });
    doc.addEventListener('pointerdown', function (e) { if (!ds.hidden && !hop.contains(e.target)) dongLai(false); }, true);
    doc.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !ds.hidden) dongLai(true); });

    /* select goc doi tu noi khac (may tinh size Apply, engine reset...) -> ve lai o; select goc nhan focus
       (engine cuon toi o thieu) -> chuyen focus sang o moi */
    sel.addEventListener('change', veNut);
    sel.addEventListener('focus', function () { if (!laMb()) nut.focus(); });
    /* lop cua o / truong doi (vien do khi thieu) hoac doi kho man hinh -> chep lai kieu */
    var f = sel.closest('.cfield') || sel.parentElement;
    if (window.MutationObserver) {
      new MutationObserver(function () { requestAnimationFrame(chepKieu); }).observe(f, { attributes: true, attributeFilter: ['class'] });
      new MutationObserver(function () { veDanhSach(); veNut(); }).observe(sel, { childList: true });
    }
    window.addEventListener('resize', function () { requestAnimationFrame(chepKieu); });

    /* ---- 03/10 (chu shop): MOBILE (<750) dung lai <select> GOC (giong Lug Width), chi doi chu option thanh
       "M — 115/70 mm (16.5–17 cm)" (so co tay lay tu bang size). PC giu dropdown tu dung. Value / property khong doi.
       Nhan tren mobile van chi "M — 115/70 mm": bo phan "(… cm)" khoi chu gia tri ma engine ghi vao nhan. */
    var MB = window.matchMedia ? window.matchMedia('(max-width: 749px)') : null;
    var hangNhan = f.querySelector('.cfield__labelrow') || f;
    var CM = /\s*\([^()]*cm\)\s*$/;
    function nganNhan() {
      if (!laMb()) return;
      var h = hangNhan.querySelectorAll('.hint');
      for (var i = 0; i < h.length; i++) { var t = h[i].textContent; if (CM.test(t)) h[i].textContent = t.replace(CM, ''); }
    }
    function cheDo() {
      var mb = laMb();
      for (var i = 0; i < sel.options.length; i++) {
        var o = sel.options[i], muon = chuNgan(o);   /* 03/10: dong = chu ngan ca mobile; cm chi gan luc mo picker (moDai) */
        if (o.textContent !== muon) o.textContent = muon;
      }
      if (mb) {
        dongLai(false); hop.hidden = true;
        sel.classList.remove('clen-an'); sel.removeAttribute('tabindex'); sel.removeAttribute('aria-hidden');
      } else {
        hop.hidden = false;
        sel.classList.add('clen-an'); sel.setAttribute('tabindex', '-1'); sel.setAttribute('aria-hidden', 'true');
        veDanhSach(); veNut();
      }
      nganNhan();
    }
    if (window.MutationObserver) new MutationObserver(nganNhan).observe(hangNhan, { childList: true, characterData: true, subtree: true });
    if (MB) { if (MB.addEventListener) MB.addEventListener('change', cheDo); else if (MB.addListener) MB.addListener(cheDo); }

    /* ---- 03/10 (chu shop): CAC O CHU tren MOBILE (<750): Lug Width, Strap Length, Thickness, Engraving, Custom Length —
       chieu cao NHIN THAY bang nut Spring Bars (Regular / Quick release; khong co nut do thi 40px); co chu NHIN THAY giu nhu
       hien tai (Custom = co chu Lug Width); chu THAT >= 16px (iPhone khong zoom): ve 16px roi transform scale(s), s = chu
       nhin thay / 16, moi so khac chia s, le am bu cho trong. Vien, bo goc nhin thay giu nguyen.
       PC (>=750): go het kieu inline cua 4 o; o Custom chep thang o Lug Width (co chu, cao, dem, vien, bo). */
    var oc = (sel.form || doc).querySelector('input[name="properties[Custom Length]"]');
    if (oc) oc.placeholder = 'e.g. 118/72 mm or wrist 17.5 cm';
    var goc = sel.form || doc;
    var lugSel = goc.querySelector('select[name="properties[Lug Width]"]');
    var DS_O = [lugSel, sel, goc.querySelector('select[name="properties[Thickness]"]'), goc.querySelector('input[name="properties[Engraving]"]')].filter(Boolean);
    var DA_DAT = ['font-size', 'font-family', 'box-sizing', 'height', 'min-height', 'max-height', 'padding-top', 'padding-bottom', 'padding-left',
      'padding-right', 'border-width', 'border-style', 'border-radius', 'max-width', 'margin-top', 'margin-right', 'margin-bottom',
      'transform', 'transform-origin', 'width', 'background-position', 'background-size',
      'border-top-color', 'border-right-color', 'border-bottom-color', 'border-left-color'];
    function goKieu(el) { for (var i = 0; i < DA_DAT.length; i++) el.style.removeProperty(DA_DAT[i]); }
    /* so do NHIN THAY cua mot o theo CSS goc (phai go kieu inline truoc khi doc) */
    function doGoc(el) {
      var c = getComputedStyle(el), k = heSo(c);
      return { f: parseFloat(c.fontSize) * k, pad: parseFloat(c.paddingLeft) * k, b: parseFloat(c.borderTopWidth) * k,
        r: parseFloat(c.borderTopLeftRadius) * k, bs: c.borderTopStyle, ff: c.fontFamily, k: k,
        bgPos: c.backgroundPosition, bgSize: c.backgroundSize, h: el.getBoundingClientRect().height };
    }
    function caoDich() {
      var sp = goc.querySelector('input[name="properties[Spring bar]"]');
      var nutSp = sp && sp.closest('label');
      var h = nutSp && nutSp.getClientRects().length ? nutSp.getBoundingClientRect().height : 0;
      return (h > 24 && h < 60) ? h : 40;   /* nut that (vien thuoc) moi lay; the anh cao (ban live) -> 40 */
    }
    function apKieu(el, m, H, fVis) {
      var s = 1, fThat = fVis;
      if (fVis < 16) { s = fVis / 16; fThat = 16; }
      var st = el.style, px = function (n) { return (n / s).toFixed(3) + 'px'; };
      var doiSo = function (x) { return x.replace(/(-?\d*\.?\d+)px/g, function (_, n) { return (parseFloat(n) * m.k / s).toFixed(3) + 'px'; }); };
      st.setProperty('font-size', fThat.toFixed(3) + 'px'); st.setProperty('font-family', m.ff);
      st.setProperty('box-sizing', 'border-box');
      st.setProperty('height', px(H)); st.setProperty('min-height', px(H)); st.setProperty('max-height', 'none');
      st.setProperty('padding-top', '0'); st.setProperty('padding-bottom', '0');
      st.setProperty('padding-left', px(m.pad)); st.setProperty('padding-right', px(m.pad));
      st.setProperty('border-width', px(m.b)); st.setProperty('border-style', m.bs); st.setProperty('border-radius', px(m.r));
      st.setProperty('max-width', 'none'); st.setProperty('margin-top', '0');
      if (el.tagName === 'SELECT') { st.setProperty('background-position', doiSo(m.bgPos)); st.setProperty('background-size', doiSo(m.bgSize)); }
      if (s === 1) {
        st.setProperty('transform', 'none'); st.setProperty('width', '100%');
        st.setProperty('margin-right', '0'); st.setProperty('margin-bottom', '0');
      } else {
        st.setProperty('transform', 'scale(' + s.toFixed(5) + ')'); st.setProperty('transform-origin', 'left top');
        st.setProperty('width', 'calc(100% / ' + s.toFixed(5) + ')');
        st.setProperty('margin-right', 'calc(100% - 100% / ' + s.toFixed(5) + ')');
        st.setProperty('margin-bottom', (H - H / s).toFixed(3) + 'px');
      }
    }
    var MAU_VIEN = ['border-top-color', 'border-right-color', 'border-bottom-color', 'border-left-color'];
    function khopO() {
      var i, ds = DS_O.slice(); if (oc) ds.push(oc);
      for (i = 0; i < ds.length; i++) goKieu(ds[i]);
      if (!lugSel || !lugSel.getClientRects().length) return;
      var mLug = doGoc(lugSel), cmLug = getComputedStyle(lugSel);
      if (laMb()) {
        var H = caoDich();
        for (i = 0; i < DS_O.length; i++) { var m = doGoc(DS_O[i]); apKieu(DS_O[i], m, H, m.f); }
        if (oc) apKieu(oc, mLug, H, mLug.f);
      } else if (oc) {
        /* PC: o Custom = Lug Width (khong thu) */
        oc.style.setProperty('font-size', mLug.f.toFixed(3) + 'px'); oc.style.setProperty('font-family', mLug.ff);
        oc.style.setProperty('box-sizing', 'border-box'); oc.style.setProperty('border-style', mLug.bs);
        oc.style.setProperty('padding-top', '0'); oc.style.setProperty('padding-bottom', '0');
        oc.style.setProperty('max-width', 'none'); oc.style.setProperty('margin-top', '0');
        oc.style.setProperty('transform', 'none'); oc.style.setProperty('width', '100%');
        oc.style.setProperty('margin-right', '0'); oc.style.setProperty('margin-bottom', '0');
        oc.style.setProperty('height', mLug.h.toFixed(3) + 'px'); oc.style.setProperty('min-height', mLug.h.toFixed(3) + 'px');
        oc.style.setProperty('padding-left', mLug.pad.toFixed(3) + 'px'); oc.style.setProperty('padding-right', mLug.pad.toFixed(3) + 'px');
        oc.style.setProperty('border-width', mLug.b.toFixed(3) + 'px'); oc.style.setProperty('border-radius', mLug.r.toFixed(3) + 'px');
      }
      if (oc) {
        var fo = oc.closest('.cfield');
        var loi = fo && (fo.classList.contains('has-error') || fo.classList.contains('is-thieu'));
        for (i = 0; i < MAU_VIEN.length; i++) { if (!loi) oc.style.setProperty(MAU_VIEN[i], cmLug.getPropertyValue(MAU_VIEN[i])); }
      }
    }
    var choKhop = 0;
    function henKhop() { cancelAnimationFrame(choKhop); choKhop = requestAnimationFrame(khopO); }
    window.addEventListener('resize', henKhop);
    if (MB) { if (MB.addEventListener) MB.addEventListener('change', henKhop); else if (MB.addListener) MB.addListener(henKhop); }
    if (oc) {
      sel.addEventListener('change', function () { setTimeout(henKhop, 30); });
      var fc = oc.closest('.cfield');
      if (fc && window.MutationObserver) new MutationObserver(henKhop).observe(fc, { attributes: true, attributeFilter: ['class', 'hidden'] });
    }
    /* nut Spring Bars / truong dang an hien sau (JS khac dung xong) -> do lai sau khi trang tai xong */
    window.addEventListener('load', henKhop);
    setTimeout(henKhop, 600);

    /* ---- 03/10 (chu shop): o Strap Length (picker goc, mobile): khi DONG chi hien chu ngan "M/L — 120/70 mm";
       phan "(… cm)" chi gan vao chu option luc MO picker (focus / cham), bo luc blur / change. Value khong doi. */
    function moDai() { if (!laMb()) return; for (var i = 0; i < sel.options.length; i++) { var o = sel.options[i], d = chuDai(o); if (o.textContent !== d) o.textContent = d; } }
    function veNgan() { for (var i = 0; i < sel.options.length; i++) { var o = sel.options[i], n = chuNgan(o); if (o.textContent !== n) o.textContent = n; } }
    sel.addEventListener('focus', moDai);
    sel.addEventListener('mousedown', moDai);
    sel.addEventListener('touchstart', moDai, { passive: true });
    sel.addEventListener('blur', veNgan);
    (sel.closest('.cstrap-section') || doc).addEventListener('change', function (e) { if (e.target === sel) veNgan(); }, true);

    veDanhSach(); veNut(); cheDo(); khopO();
  }
  function khoi() {
    var ds = document.querySelectorAll('.cstrap-section select[name="properties[Length]"]');
    for (var i = 0; i < ds.length; i++) { try { cstrapLenDropdown(ds[i]); } catch (e) { console.warn('cstrap-len:', e); } }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', khoi); else khoi();
})();
